import * as actions from '../actions.const';
import { SectinTypes } from '../actions.const';
import { getActionName } from './get-action-name';

export interface ActionsNames {
  action: string;
  request: string;
  successful: string;
  failure: string;
}

export interface GetActionsOptions {
  context: string;
  feature: string;
  section: SectinTypes | string;
  action: string;
}

export function getActionsNames({
  context,
  feature,
  section,
  action,
}: Partial<GetActionsOptions>): ActionsNames {
  const rv: ActionsNames = {
    action: getActionName({
      context,
      feature,
      section,
      action,
    }),
    request: getActionName({
      context,
      feature,
      section,
      action,
      event: actions.request,
    }),
    successful: getActionName({
      context,
      feature,
      section,
      action,
      event: actions.successful,
    }),
    failure: getActionName({
      context,
      feature,
      section,
      action,
      event: actions.failure,
    }),
  };
  return rv;
}
